import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/home/Home.vue'    //主页
import News from './pages/news/News.vue'    //新闻咨询
import Activity from './pages/activity/Activity.vue'   //文旅活动
import Item from './pages/item/Item.vue'    //招标项目
import Mall from './pages/mall/Mall'    //文创商城
import Equity from './pages/equity/Equity'  //知识产权
import Policy from './pages/policy/Policy'  //扶持政策
import Bloc from './pages/bloc/Bloc'  //产业联盟
import About from './pages/about/About'  //关于协会
import Detail from './pages/detail/Detail'  //详情
import Video from './pages/video/Video'  //视频页
import Pavilion from './pages/pavilion/Pavilion';   //虚拟展馆
import Virtual from './pages/virtual/Virtual';   //虚拟展馆
import yxcp from './pages/yxcp/index';   //优选产品
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'Home',
        component: Home
    }, {
        path: '/news',
        name: 'News',
        component: News
    }, {
        path: '/activity',
        name: 'Activity',
        component: Activity
    }, {
        path: '/item',
        name: 'Item',
        component: Item
    }, {
        path: '/mall',
        name: 'Mall',
        component: Mall
    }, {
        path: '/equity',
        name: 'Equity',
        component: Equity
    }, {
        path: '/policy',
        name: 'Policy',
        component: Policy
    }, {
        path: '/bloc',
        name: 'Bloc',
        component: Bloc
    }, {
        path: '/about',
        name: 'About',
        component: About
    }, {
        path: '/detail',
        name: 'Detail',
        component: Detail
    }, {
        path: '/video',
        name: 'Video',
        component: Video
    }, {
        path: '/pavilion',
        name: 'Pavilion',
        component: Pavilion
    }, {
        path: '/virtual',
        name: 'Virtual',
        component: Virtual
    }, {
        path: '/yxcp',
        name: 'yxcp',
        component: yxcp
    }]
})
